// extracted by mini-css-extract-plugin
module.exports = {"root":"AdminContainer_root__3TzIk"};